import { useMount, segment, useAuth } from "@granular/fabric3-core";

/**
 * TODO: Add a message maybe?
 *
 * TODO: What do we do when logout fails? What are we showing the user?
 */

const Logout = () => {
  const auth = useAuth();

  useMount(() => {
    void segment.track("select Log Out");
    void (async () => {
      try {
        await auth.logout();
      } catch (error) {
        console.error("Logout Error:", error);
      }
    })();
  });

  return "";
};

export default Logout;
